var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TranslateService } from '@ngx-translate/core';
import { apiEndpoints, CommonConstant } from '../../app.constants';
import { BackendHttpService } from '../../core/backend-http.service';
import { Router } from '@angular/router';
import * as Chains from 'c4s';
import { EventTrackerService, Page, UserActionType, ActionSource } from '../event-tracker/event-tracker.service';
import * as Sentry from '@sentry/browser';
var MentionService = /** @class */ (function (_super) {
    __extends(MentionService, _super);
    function MentionService(router, translate, eventTracker) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.eventTracker = eventTracker;
        return _this;
    }
    MentionService.prototype.addNewProjectMention = function (mention) {
        return this.post(apiEndpoints.addNewProjectMention, mention);
    };
    MentionService.prototype.deleteMention = function (mentionId) {
        var deleteUrl = apiEndpoints.deleteMention;
        return this.delete(deleteUrl + "/" + mentionId);
    };
    MentionService.prototype.searchMention = function (searchCriteria) {
        return this.post(apiEndpoints.searchMention, searchCriteria).map(function (res) { return res.data; });
    };
    /**
     * this method is use to find an existing mention by name
     * @param {string} mentionName
     * @returns {Observable<MentionResponse>}
     */
    MentionService.prototype.findMentionByName = function (mentionName) {
        return this.post(apiEndpoints.exists, {
            countries: [CommonConstant.INTERNATIONAL_ID],
            keyword: mentionName
        }).map(function (res) { return res.data.keyword; });
    };
    /**
     * An action chain for new mention
     * - do before
     * - check exist
     * - add new mention if not existed and can create new
     * - do after
     * - track event to Segement
     * @param mention
     * @param beforeProcessing
     * @param afterProcessing
     * @param {ActivePage} activePage
     * @param {ActionSource} actionSource
     * @param {boolean} canCreate
     */
    MentionService.prototype.processNewMention = function (mention, beforeProcessing, afterProcessing, activePage, actionSource, canCreate) {
        if (canCreate === void 0) { canCreate = true; }
        var state = {
            mentionService: this,
            eventTracker: this.eventTracker,
            beforeProcessing: beforeProcessing,
            afterProcessing: afterProcessing,
            mention: mention,
            persistedMention: null,
            hasError: false,
            activePage: activePage,
            actionSource: actionSource,
            canCreate: canCreate
        };
        // Run requests sequentially
        Chains(state)
            .then(this.doBeforeProcessingMention)
            .then(this.checkPostMentionExist)
            .then(this.addNewMention)
            .then(this.afterAddNewMentionSuccess)
            .catch(function (error) {
            console.warn(error);
            // Report to Sentry
            var reported_error;
            if (error instanceof Error) {
                reported_error = error;
            }
            else if (error && error.message) {
                reported_error = new Error(error.message);
            }
            else {
                reported_error = new Error(error.toString());
            }
            Sentry.captureException(reported_error);
        });
    };
    MentionService.prototype.doBeforeProcessingMention = function (state, next) {
        if (state.beforeProcessing) {
            state.beforeProcessing(state.mention);
        }
        return next();
    };
    // Check if a mention exists
    MentionService.prototype.checkPostMentionExist = function (state, next) {
        state.mentionService.findMentionByName(state.mention.keyword).subscribe(
        // Success
        function (data) {
            state.mention_exists = !!data.id;
            state.persistedMention = data;
            return next();
        }, 
        // Error
        function (error) {
            return next(error);
        });
    };
    // Create a new mention
    MentionService.prototype.addNewMention = function (state, next) {
        // Mention already exists, skip this
        if (state.mention_exists || !state.canCreate) {
            return next();
        }
        // Make API call
        state.mentionService.addNewProjectMention(state.mention)
            .subscribe(function (resp) {
            state.persistedMention = resp.mention;
            return next();
        }, function (err) {
            state.hasError = true;
            return next();
        });
    };
    MentionService.prototype.afterAddNewMentionSuccess = function (state, next) {
        if (!state.hasError && !state.mention_exists && state.canCreate) {
            var newMention = state.persistedMention;
            // keep track event to Segment
            state.eventTracker.trackUserAction(UserActionType.ACTION, Page.MENTION, {
                id: newMention.id,
                name: newMention.keyword,
                type: newMention.keywordType.name
            }, __assign({ action: UserActionType.CREATE, source: state.actionSource || ActionSource.PAGE }, newMention), undefined, {
                type: state.activePage.type,
                name: state.activePage.name,
                id: state.activePage.id,
            });
        }
        if (!state.afterProcessing) {
            return next();
        }
        state.afterProcessing({
            hasError: state.hasError,
            alreadyExisted: state.mention_exists,
            newMention: state.persistedMention,
            errorMention: state.mention
        });
        return next();
    };
    return MentionService;
}(BackendHttpService));
export { MentionService };



// WEBPACK FOOTER //
// ./src/app/services/mention/mention.service.ts.pre-build-optimizer.js